// @ts-nocheck
import { Component } from '@theme/component';
import { fetchConfig, debounce, resetShimmer } from '@theme/utilities';
import { morph } from '@theme/morph';
import { morphSection, sectionRenderer } from '@theme/section-renderer';
import {
  ThemeEvents,
  CartUpdateEvent,
  QuantitySelectorUpdateEvent,
  CartAddEvent,
  DiscountUpdateEvent,
} from '@theme/events';
import { cartPerformance } from '@theme/performance';

let egReflowRaf = 0;
let egResizeTimer = 0;

function egEnsureOptimisticRemoveStyles() {
  if (document.getElementById('eg-cart-optimistic-remove-styles')) return;

  const style = document.createElement('style');
  style.id = 'eg-cart-optimistic-remove-styles';
  style.textContent = `
    cart-items-component [data-key].eg-cart-row--pending-remove {
      display: none !important;
      pointer-events: none !important;
    }

    cart-items-component [data-key].eg-cart-row--pending-remove * {
      pointer-events: none !important;
    }

    cart-items-component [data-key].eg-cart-row--flip-moving {
      will-change: transform !important;
    }

    cart-items-component [data-key].eg-cart-row--top-border-while-pending {
      position: relative !important;
    }

    cart-items-component [data-key].eg-cart-row--top-border-while-pending::before {
      content: '' !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      z-index: 2 !important;
      display: block !important;
      width: 100% !important;
      height: 1px !important;
      background: #000 !important;
      pointer-events: none !important;
    }

    cart-items-component .cart-drawer__meta.eg-cart-meta-loading,
    .cart-drawer__meta.eg-cart-meta-loading {
      display: inline-flex !important;
      align-items: center !important;
      gap: 0 !important;
      animation: none !important;
      will-change: auto !important;
    }

    cart-items-component .cart-drawer__meta.eg-cart-meta-loading::after,
    .cart-drawer__meta.eg-cart-meta-loading::after {
      content: none !important;
      display: none !important;
    }

    cart-items-component:has(.cart-drawer__meta.eg-cart-meta-loading) .cart-drawer__meta-row::after {
      content: '' !important;
      display: inline-block !important;
      width: 11px !important;
      height: 11px !important;
      flex: 0 0 11px !important;
      border: 1.5px solid rgba(0, 0, 0, .18) !important;
      border-top-color: currentColor !important;
      border-radius: 50% !important;
      opacity: .72 !important;
      animation: egCartMetaSpin 720ms linear infinite !important;
    }

    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty {
      position: relative !important;
    }

    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty:has(dialog[open]:not([data-eg-state="closing"]))::after {
      content: '' !important;
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      z-index: 3 !important;
      transform: translate3d(-50%, -50%, 0) !important;
      display: block !important;
      width: 18px !important;
      height: 18px !important;
      border: 1.5px solid rgba(0, 0, 0, .16) !important;
      border-top-color: rgba(0, 0, 0, .66) !important;
      border-radius: 50% !important;
      pointer-events: none !important;
      animation: egCartCenteredSpin 720ms linear infinite !important;
    }

    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty:not(:has(dialog[open]:not([data-eg-state="closing"])))::after {
      content: none !important;
      display: none !important;
    }

    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty .cart-drawer__footer,
    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty .cart-drawer__summary,
    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty .cart__footer,
    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty .cart__summary,
    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty cart-summary,
    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty [ref="cartTotal"],
    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty [name="checkout"],
    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]).eg-cart-drawer-pending-empty a[href*="/checkout"] {
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
      transition: opacity 120ms ease !important;
    }

    :is(cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]) :is(button[name="checkout"], input[name="checkout"], .eg-cart-checkout)[data-eg-checkout-updating="true"] {
      pointer-events: none !important;
      cursor: progress !important;
    }

    .eg-cart-undo-toast {
      position: fixed !important;
      right: 20px !important;
      bottom: 20px !important;
      z-index: 9999 !important;
      display: inline-flex !important;
      align-items: center !important;
      gap: 14px !important;
      min-height: 42px !important;
      padding: 0 14px !important;
      background: #000 !important;
      color: #fff !important;
      font-family: inherit !important;
      font-size: 12px !important;
      line-height: 1 !important;
      opacity: 0 !important;
      transform: translate3d(0, 8px, 0) !important;
      pointer-events: none !important;
      transition:
        opacity 180ms ease,
        transform 180ms ease !important;
    }

    .eg-cart-undo-toast[data-visible='true'] {
      opacity: 1 !important;
      transform: translate3d(0, 0, 0) !important;
      pointer-events: auto !important;
    }

    .eg-cart-undo-toast__button {
      appearance: none !important;
      -webkit-appearance: none !important;
      border: 0 !important;
      background: transparent !important;
      color: inherit !important;
      font: inherit !important;
      line-height: 1 !important;
      letter-spacing: .04em !important;
      text-transform: uppercase !important;
      text-decoration: underline !important;
      text-underline-offset: 3px !important;
      padding: 0 !important;
      cursor: pointer !important;
    }

    .eg-cart-undo-toast__button[disabled] {
      opacity: .5 !important;
      cursor: progress !important;
    }

    @media screen and (max-width: 749px) {
      .eg-cart-undo-toast {
        right: 16px !important;
        left: 16px !important;
        justify-content: space-between !important;
      }
    }

    @keyframes egCartMetaSpin {
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes egCartCenteredSpin {
      to {
        transform: translate3d(-50%, -50%, 0) rotate(360deg);
      }
    }
  `;

  document.head.appendChild(style);
}

function egScheduleReflowResize() {
  if (egReflowRaf) return;

  document.body.classList.add('reflow');

  egReflowRaf = requestAnimationFrame(() => {
    egReflowRaf = 0;
    document.body.classList.remove('reflow');

    if (egResizeTimer) return;

    egResizeTimer = window.setTimeout(() => {
      egResizeTimer = 0;
      window.dispatchEvent(new Event('resize'));
    }, 120);
  });
}

/** @typedef {import('./utilities').TextComponent} TextComponent */

class CartItemsComponent extends Component {
  #debouncedOnChange = debounce(this.#onQuantityChange, 220).bind(this);
  #isCartMutationInFlight = false;
  #queuedMutations = new Map();
  #requestSequence = 0;
  #activeMutation = null;
  #activeBatchMutations = [];
  #deferredCartMutationResponse = null;
  #deferredCartMutationTimer = null;
  #flipTimers = new Map();
  #cartMetaLoading = false;
  #cartMetaLoadingTimer = null;
  #lastConfirmedCartCount = null;
  #manualRemovalStreak = 0;
  #hasShownClearPromptThisOpen = false;
  #clearCartUndoItems = [];
  #clearCartUndoTimer = null;
  #clearCartUndoToast = null;
  #checkoutLoadingText = 'Updating...';

  connectedCallback() {
    super.connectedCallback();

    egEnsureOptimisticRemoveStyles();
    this.#lastConfirmedCartCount = this.#readOwnCartCount();

    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
    document.addEventListener('submit', this.#handlePotentialCartAddSubmit, true);
    document.addEventListener('dialog:closing', this.#handleCartDrawerDialogClosing, true);
    document.addEventListener('dialog:close', this.#handleCartDrawerDialogClose, true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    document.removeEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
    document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
    document.removeEventListener('submit', this.#handlePotentialCartAddSubmit, true);
    document.removeEventListener('dialog:closing', this.#handleCartDrawerDialogClosing, true);
    document.removeEventListener('dialog:close', this.#handleCartDrawerDialogClose, true);

    for (const timer of this.#flipTimers.values()) {
      window.clearTimeout(timer);
    }

    if (this.#deferredCartMutationTimer) {
      window.clearTimeout(this.#deferredCartMutationTimer);
      this.#deferredCartMutationTimer = null;
    }

    if (this.#cartMetaLoadingTimer) {
      window.clearTimeout(this.#cartMetaLoadingTimer);
      this.#cartMetaLoadingTimer = null;
    }

    if (this.#clearCartUndoTimer) {
      window.clearTimeout(this.#clearCartUndoTimer);
      this.#clearCartUndoTimer = null;
    }

    this.#clearCartUndoToast?.remove();
    this.#clearCartUndoToast = null;
    this.#flipTimers.clear();
  }

  _isEgHeaderContext() {
    return Boolean(this.closest('[data-eg-header], .eg-header'));
  }

  #isCartDrawerContext() {
    return Boolean(
      this.closest(
        'cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]'
      )
    );
  }

  #getCartDrawerRoots() {
    const roots = new Set();

    const ownRoot = this.closest(
      'cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]'
    );

    if (ownRoot) {
      roots.add(ownRoot);
    }

    document
      .querySelectorAll('cart-drawer-component, cart-drawer, .cart-drawer, .cart-drawer-component, [data-cart-drawer]')
      .forEach((root) => {
        roots.add(root);
      });

    return Array.from(roots).filter((root) => root instanceof HTMLElement);
  }

  #isCartDrawerRootOpen(root) {
    if (!(root instanceof HTMLElement)) return false;

    if (
      root.matches('dialog[open]:not([data-eg-state="closing"]), .cart-drawer__dialog[open]:not([data-eg-state="closing"])')
    ) {
      return true;
    }

    return Boolean(
      root.querySelector?.('dialog[open]:not([data-eg-state="closing"]), .cart-drawer__dialog[open]:not([data-eg-state="closing"])')
    );
  }

  #isCartDrawerRootClosing(root) {
    if (!(root instanceof HTMLElement)) return false;

    if (
      root.matches('dialog[open][data-eg-state="closing"], .cart-drawer__dialog[open][data-eg-state="closing"]')
    ) {
      return true;
    }

    return Boolean(
      root.querySelector?.('dialog[open][data-eg-state="closing"], .cart-drawer__dialog[open][data-eg-state="closing"]')
    );
  }

  #isAnyCartDrawerOpen() {
    return this.#getCartDrawerRoots().some((root) => this.#isCartDrawerRootOpen(root));
  }

  #isAnyCartDrawerClosing() {
    return this.#getCartDrawerRoots().some((root) => this.#isCartDrawerRootClosing(root));
  }

  #cartDrawerEventBelongsToThisCart(event) {
    const target = event?.target;

    return this.#getCartDrawerRoots().some((root) => {
      return root === target || (target instanceof Node && root.contains(target));
    });
  }

  #handleCartDrawerDialogClosing = (event) => {
    if (!this.#cartDrawerEventBelongsToThisCart(event)) return;

    this.#restoreCartMetaText();
    this.#syncCartDrawerLoadingState();
  };

  #handleCartDrawerDialogClose = (event) => {
    if (!this.#cartDrawerEventBelongsToThisCart(event)) return;

    requestAnimationFrame(() => {
      this.#resetManualRemovalStreak();
      this.#syncCartDrawerLoadingState();
      this.#scheduleDeferredCartMutationResponseFlush(120);
    });
  };

  _findSelfInSectionHtml(sectionHtml) {
    const preparedSectionHtml = this.#prepareSectionHtmlWithPendingStates(sectionHtml);
    const doc = new DOMParser().parseFromString(preparedSectionHtml, 'text/html');
    const sectionRoot = doc.getElementById(`shopify-section-${this.sectionId}`) || doc.body;

    return (
      sectionRoot.querySelector('cart-drawer-component cart-items-component') ||
      sectionRoot.querySelector(`cart-items-component[data-section-id="${this.sectionId}"]`) ||
      sectionRoot.querySelector('cart-items-component') ||
      null
    );
  }

  _morphSelfFromSectionHtml(sectionHtml) {
    if (typeof sectionHtml !== 'string' || sectionHtml.trim() === '') return false;

    const newSelf = this._findSelfInSectionHtml(sectionHtml);
    if (!newSelf) return false;

    morph(this, newSelf);

    queueMicrotask(() => {
      this.#updateCartQuantitySelectorButtonStates();
      this.#applyPendingStates();
      egScheduleReflowResize();
    });

    return true;
  }

  async _renderSelfFromSectionApi() {
    try {
      const sectionId = this.sectionId.startsWith('shopify-section-')
        ? this.sectionId.replace(/^shopify-section-/, '')
        : this.sectionId;

      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.sort();

      const html = await fetch(url.toString()).then((r) => r.text());
      this._morphSelfFromSectionHtml(html);
    } catch (_) {}
  }

  #normalizeLine(line) {
    const parsed = Number(line);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  #normalizeCount(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed)) : null;
  }

  #escapeCss(value) {
    const raw = String(value ?? '');

    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return CSS.escape(raw);
    }

    return raw.replace(/([ #;?%&,.+*~\\':"!^$[\]()=>|/@])/g, '\\$1');
  }

  #getRows() {
    return Array.isArray(this.refs.cartItemRows) ? this.refs.cartItemRows : [];
  }

  #getVisibleCartRowCount() {
    return this.#getRows().filter((row) => {
      return row instanceof HTMLElement &&
        row.isConnected &&
        !row.classList.contains('eg-cart-row--pending-remove');
    }).length;
  }

  #getContextualClearElements() {
    return Array.from(this.querySelectorAll('[data-eg-cart-context-clear]')).filter(
      (element) => element instanceof HTMLElement
    );
  }

  #syncContextualClearState() {
    const shouldShow =
      this.#manualRemovalStreak >= 3 &&
      this.#getVisibleCartRowCount() > 0;

    for (const element of this.#getContextualClearElements()) {
      if (shouldShow && this.#hasShownClearPromptThisOpen) {
        element.setAttribute('data-eg-cart-prompt-stable', 'true');
      } else if (shouldShow) {
        this.#hasShownClearPromptThisOpen = true;
      }

      if (!shouldShow) {
        element.removeAttribute('data-eg-cart-prompt-stable');
      }

      element.hidden = !shouldShow;
      element.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }
  }

  #recordManualRemoval() {
    this.#manualRemovalStreak += 1;
    this.#syncContextualClearState();
  }

  #resetManualRemovalStreak() {
    this.#manualRemovalStreak = 0;
    this.#hasShownClearPromptThisOpen = false;
    this.#syncContextualClearState();
  }

  #getCheckoutControls(root) {
    if (!(root instanceof HTMLElement)) return [];

    return Array.from(root.querySelectorAll('button[name="checkout"], input[name="checkout"], .eg-cart-checkout')).filter(
      (control) => control instanceof HTMLElement
    );
  }

  #getCheckoutControlText(control) {
    if (control instanceof HTMLInputElement) {
      return control.value || control.getAttribute('value') || '';
    }

    return control.textContent || '';
  }

  #setCheckoutControlText(control, text) {
    if (control instanceof HTMLInputElement) {
      control.value = text;
      return;
    }

    control.textContent = text;
  }

  #setCheckoutControlLoading(control, loading) {
    if (!(control instanceof HTMLElement)) return;

    if (loading) {
      if (!control.hasAttribute('data-eg-checkout-original-text')) {
        control.setAttribute('data-eg-checkout-original-text', this.#getCheckoutControlText(control));
      }

      if (
        control instanceof HTMLButtonElement ||
        control instanceof HTMLInputElement ||
        control instanceof HTMLSelectElement ||
        control instanceof HTMLTextAreaElement
      ) {
        if (!control.hasAttribute('data-eg-checkout-original-disabled')) {
          control.setAttribute('data-eg-checkout-original-disabled', control.disabled ? 'true' : 'false');
        }

        control.disabled = true;
      }

      control.setAttribute('aria-disabled', 'true');
      control.setAttribute('aria-busy', 'true');
      control.setAttribute('data-eg-checkout-updating', 'true');
      this.#setCheckoutControlText(control, this.#checkoutLoadingText);
      return;
    }

    const originalText = control.getAttribute('data-eg-checkout-original-text');

    if (originalText !== null) {
      this.#setCheckoutControlText(control, originalText);
      control.removeAttribute('data-eg-checkout-original-text');
    }

    if (
      control instanceof HTMLButtonElement ||
      control instanceof HTMLInputElement ||
      control instanceof HTMLSelectElement ||
      control instanceof HTMLTextAreaElement
    ) {
      const originalDisabled = control.getAttribute('data-eg-checkout-original-disabled');

      if (originalDisabled !== null) {
        control.disabled = originalDisabled === 'true';
        control.removeAttribute('data-eg-checkout-original-disabled');
      }
    }

    control.removeAttribute('aria-disabled');
    control.removeAttribute('aria-busy');
    control.removeAttribute('data-eg-checkout-updating');
  }

  #syncCheckoutControlsForRoot(root, loading = this.#cartMetaLoading) {
    for (const control of this.#getCheckoutControls(root)) {
      this.#setCheckoutControlLoading(control, loading);
    }
  }

  #syncCartDrawerLoadingState() {
    const isDrawerOpen = this.#isAnyCartDrawerOpen();
    const hasPendingMutation = this.#hasPendingCartMutation();
    const pendingEmpty =
      this.#cartMetaLoading &&
      isDrawerOpen &&
      this.#getPendingRemovalKeys().length > 0 &&
      this.#getVisibleCartRowCount() === 0;

    this.toggleAttribute('data-eg-cart-mutating', this.#cartMetaLoading || hasPendingMutation);

    for (const root of this.#getCartDrawerRoots()) {
      const showLoading = this.#cartMetaLoading && this.#isCartDrawerRootOpen(root);
      const rootHasMutation = this.#cartMetaLoading || hasPendingMutation;

      root.classList.toggle('eg-cart-drawer-loading', showLoading);
      root.classList.toggle('eg-cart-drawer-pending-empty', pendingEmpty);

      if (rootHasMutation) {
        root.setAttribute('data-eg-cart-mutating', 'true');
      } else {
        root.removeAttribute('data-eg-cart-mutating');
      }

      if (showLoading) {
        root.setAttribute('data-eg-cart-drawer-loading', 'true');
      } else {
        root.removeAttribute('data-eg-cart-drawer-loading');
      }

      if (pendingEmpty) {
        root.setAttribute('data-eg-cart-pending-empty', 'true');
      } else {
        root.removeAttribute('data-eg-cart-pending-empty');
      }

      this.#syncCheckoutControlsForRoot(root, showLoading);
    }

    this.#syncContextualClearState();
  }

  #getRowByLine(line) {
    const normalizedLine = this.#normalizeLine(line);
    if (!normalizedLine) return null;

    return this.refs.cartItemRows?.[normalizedLine - 1] || null;
  }

  #getRowKeyByLine(line) {
    return this.#getRowByLine(line)?.dataset?.key || '';
  }

  #findRowByKey(key) {
    if (!key) return null;

    return this.querySelector(`[data-key="${this.#escapeCss(key)}"]`);
  }

  #resolveRowFromEvent(event) {
    const target = event?.target;
    if (!(target instanceof Element)) return null;

    const row = target.closest('[data-key]');
    if (!(row instanceof HTMLElement)) return null;
    if (!this.contains(row)) return null;

    return row;
  }

  #resolveLineFromMutation(mutation) {
    if (mutation?.key) {
      const row = this.#findRowByKey(mutation.key);

      if (row) {
        const input = row.querySelector('input[data-cart-line]');
        const lineFromInput = Number(input?.dataset?.cartLine || 0);

        if (lineFromInput > 0) return lineFromInput;

        const rows = this.#getRows();
        const rowIndex = rows.indexOf(row);

        if (rowIndex >= 0) return rowIndex + 1;
      }
    }

    return this.#normalizeLine(mutation?.line || 0);
  }

  #getPendingRemovalKeys() {
    const keys = [];

    for (const mutation of this.#queuedMutations.values()) {
      if (mutation?.quantity === 0 && mutation?.key) {
        keys.push(mutation.key);
      }
    }

    if (this.#activeMutation?.quantity === 0 && this.#activeMutation?.key) {
      keys.push(this.#activeMutation.key);
    }

    for (const mutation of this.#activeBatchMutations) {
      if (mutation?.quantity === 0 && mutation?.key) {
        keys.push(mutation.key);
      }
    }

    return keys;
  }

  #hasPendingCartMutation() {
    return (
      this.#isCartMutationInFlight ||
      this.#queuedMutations.size > 0 ||
      Boolean(this.#activeMutation) ||
      this.#activeBatchMutations.length > 0
    );
  }

  #getRowQuantity(row) {
    if (!(row instanceof HTMLElement)) return 1;

    const input = row.querySelector('input[data-cart-line], input[name="updates[]"], input[ref="quantityInput"]');

    const candidates = [
      input?.value,
      input?.defaultValue,
      input?.getAttribute?.('value'),
    ];

    for (const candidate of candidates) {
      const parsed = Number(candidate);

      if (Number.isFinite(parsed) && parsed > 0) {
        return Math.round(parsed);
      }
    }

    return 1;
  }

  #formatCartMetaText(count) {
    const safeCount = Math.max(0, Math.round(Number(count) || 0));
    return `${safeCount} ${safeCount === 1 ? 'item' : 'items'} in cart`;
  }

  #readOwnCartCount() {
    return this.#normalizeCount(this.refs.cartItemCount?.textContent || this.querySelector('[ref="cartItemCount"]')?.textContent);
  }

  #getPendingRemovalQuantity() {
    const mutations = [
      ...this.#queuedMutations.values(),
      ...(this.#activeMutation ? [this.#activeMutation] : []),
      ...this.#activeBatchMutations,
    ];

    return mutations.reduce((total, mutation) => {
      if (mutation?.quantity !== 0) return total;

      const removedQuantity = this.#normalizeCount(mutation.removedQuantity);
      return total + (removedQuantity ?? 1);
    }, 0);
  }

  #getOptimisticCartCount() {
    const confirmedCount =
      this.#lastConfirmedCartCount ??
      this.#readOwnCartCount();

    if (confirmedCount === null) return null;

    return Math.max(0, confirmedCount - this.#getPendingRemovalQuantity());
  }

  #getCartMetaLoadingText() {
    const optimisticCount = this.#getOptimisticCartCount();

    if (optimisticCount !== null) {
      return this.#formatCartMetaText(optimisticCount);
    }

    return null;
  }

  #getCartMetaElements() {
    const metas = new Set();

    for (const root of this.#getCartDrawerRoots()) {
      root.querySelectorAll?.('.cart-drawer__meta')?.forEach((element) => {
        metas.add(element);
      });
    }

    document.querySelectorAll('.cart-drawer__meta').forEach((element) => {
      metas.add(element);
    });

    return Array.from(metas).filter((element) => element instanceof HTMLElement);
  }

  #setCartMetaLoadingState() {
    if (!this.#isAnyCartDrawerOpen()) {
      this.#syncCartDrawerLoadingState();
      return;
    }

    const loadingText = this.#getCartMetaLoadingText();

    for (const element of this.#getCartMetaElements()) {
      if (!element.hasAttribute('data-eg-cart-meta-before-loading')) {
        element.setAttribute('data-eg-cart-meta-before-loading', element.textContent || '');
      }

      element.classList.add('eg-cart-meta-loading');
      element.setAttribute('aria-busy', 'true');

      if (loadingText !== null) {
        element.textContent = loadingText;
      }
    }

    this.#syncCartDrawerLoadingState();
  }

  #setCartMetaCount(count) {
    const safeCount = this.#normalizeCount(count);

    if (safeCount === null) return;

    for (const element of this.#getCartMetaElements()) {
      element.classList.remove('eg-cart-meta-loading');
      element.removeAttribute('data-eg-cart-meta-before-loading');
      element.removeAttribute('aria-busy');
      element.textContent = this.#formatCartMetaText(safeCount);
    }

    this.#syncCartDrawerLoadingState();
  }

  #restoreCartMetaText() {
    for (const element of this.#getCartMetaElements()) {
      const previousText = element.getAttribute('data-eg-cart-meta-before-loading');

      if (previousText !== null) {
        element.classList.remove('eg-cart-meta-loading');
        element.removeAttribute('aria-busy');
        element.textContent = previousText;
        element.removeAttribute('data-eg-cart-meta-before-loading');
      }
    }

    this.#syncCartDrawerLoadingState();
  }

  #startCartMetaLoading(fallbackDuration = 4500) {
    this.#cartMetaLoading = true;

    if (this.#lastConfirmedCartCount === null) {
      this.#lastConfirmedCartCount = this.#readOwnCartCount();
    }

    this.#setCartMetaLoadingState();

    if (this.#cartMetaLoadingTimer) {
      window.clearTimeout(this.#cartMetaLoadingTimer);
    }

    this.#cartMetaLoadingTimer = window.setTimeout(() => {
      this.#cartMetaLoadingTimer = null;

      if (this.#hasPendingCartMutation()) {
        this.#setCartMetaLoadingState();
        this.#startCartMetaLoading(fallbackDuration);
        return;
      }

      this.#finishCartMetaLoading(this.#lastConfirmedCartCount);
    }, Math.max(1200, Number(fallbackDuration || 4500)));
  }

  #finishCartMetaLoading(count = null) {
    this.#cartMetaLoading = false;

    if (this.#cartMetaLoadingTimer) {
      window.clearTimeout(this.#cartMetaLoadingTimer);
      this.#cartMetaLoadingTimer = null;
    }

    const safeCount = this.#normalizeCount(count);

    if (safeCount !== null) {
      this.#lastConfirmedCartCount = safeCount;
      this.#setCartMetaCount(safeCount);
      return;
    }

    this.#restoreCartMetaText();
  }

  #readAbsoluteCountFromCartUpdateEvent(event) {
    const detail = event?.detail || {};
    const data = detail?.data || {};
    const source = data?.source ?? detail?.source ?? '';

    const candidates = [
      data?.cart?.item_count,
      detail?.cart?.item_count,
      detail?.resource?.item_count,
    ];

    if (source !== 'product-form-component') {
      candidates.push(data?.itemCount, detail?.itemCount);
    }

    for (const candidate of candidates) {
      const parsed = this.#normalizeCount(candidate);

      if (parsed !== null) {
        return parsed;
      }
    }

    return null;
  }

  #readCountFromSectionHtml(sectionHtml) {
    if (typeof sectionHtml !== 'string' || sectionHtml.trim() === '') return null;

    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    return this.#normalizeCount(doc.querySelector('[ref="cartItemCount"]')?.textContent);
  }

  #handlePotentialCartAddSubmit = (event) => {
    const form = event?.target;

    if (!(form instanceof HTMLFormElement)) return;

    const isProductForm =
      Boolean(form.closest('product-form-component')) ||
      String(form.getAttribute('data-type') || '').includes('add-to-cart') ||
      String(form.action || '').includes('/cart/add');

    if (!isProductForm) return;

    this.#resetManualRemovalStreak();
    this.#hideClearCartUndoToast();
    this.#startCartMetaLoading(5000);
  };

  #prepareSectionHtmlWithPendingStates(sectionHtml) {
    if (typeof sectionHtml !== 'string' || sectionHtml.trim() === '') return sectionHtml;

    const pendingKeys = new Set(this.#getPendingRemovalKeys());

    if (!pendingKeys.size && !this.#cartMetaLoading) {
      return sectionHtml;
    }

    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const rows = Array.from(doc.querySelectorAll('[data-key]'));

    if (this.#cartMetaLoading) {
      const loadingText = this.#getCartMetaLoadingText();

      doc.querySelectorAll('.cart-drawer__meta').forEach((element) => {
        element.classList.add('eg-cart-meta-loading');
        element.setAttribute('aria-busy', 'true');

        if (loadingText !== null) {
          element.textContent = loadingText;
        }
      });
    }

    if (this.#hasShownClearPromptThisOpen) {
      doc.querySelectorAll('[data-eg-cart-context-clear]').forEach((element) => {
        element.setAttribute('data-eg-cart-prompt-stable', 'true');
      });
    }

    rows.forEach((row) => {
      if (!(row instanceof HTMLElement)) return;

      row.classList.remove('eg-cart-row--top-border-while-pending');

      const key = row.dataset.key || '';

      if (!key) return;

      if (pendingKeys.has(key)) {
        row.classList.add('eg-cart-row--pending-remove');
        row.setAttribute('aria-busy', 'true');
      }
    });

    if (this.#isCartDrawerContext()) {
      let hasPendingAtTop = false;

      for (const row of rows) {
        if (!(row instanceof HTMLElement)) continue;

        const key = row.dataset.key || '';
        if (!key) continue;

        if (pendingKeys.has(key)) {
          hasPendingAtTop = true;
          continue;
        }

        if (hasPendingAtTop) {
          row.classList.add('eg-cart-row--top-border-while-pending');
        }

        break;
      }
    }

    return doc.body.innerHTML;
  }

  #captureRowPositions() {
    const positions = new Map();

    for (const row of this.#getRows()) {
      if (!(row instanceof HTMLElement)) continue;
      if (!row.isConnected) continue;
      if (row.classList.contains('eg-cart-row--pending-remove')) continue;

      const key = row.dataset.key || '';
      if (!key) continue;

      const rect = row.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) continue;

      positions.set(key, {
        top: rect.top,
        left: rect.left,
      });
    }

    return positions;
  }

  #clearFlipForRow(row) {
    if (!(row instanceof HTMLElement)) return;

    const key = row.dataset.key || '';
    if (!key) return;

    const timer = this.#flipTimers.get(key);

    if (timer) {
      window.clearTimeout(timer);
      this.#flipTimers.delete(key);
    }

    row.classList.remove('eg-cart-row--flip-moving');
    row.style.transition = '';
    row.style.transform = '';
    row.style.willChange = '';
  }

  #animateRowsFromPreviousPositions(previousPositions) {
    if (!this.#isCartDrawerContext()) return;
    if (!(previousPositions instanceof Map) || previousPositions.size === 0) return;

    const movedRows = [];

    for (const row of this.#getRows()) {
      if (!(row instanceof HTMLElement)) continue;
      if (!row.isConnected) continue;
      if (row.classList.contains('eg-cart-row--pending-remove')) continue;

      const key = row.dataset.key || '';
      if (!key || !previousPositions.has(key)) continue;

      const previousPosition = previousPositions.get(key);
      const currentRect = row.getBoundingClientRect();

      const previousTop =
        typeof previousPosition === 'number'
          ? previousPosition
          : Number(previousPosition?.top);

      const previousLeft =
        typeof previousPosition === 'number'
          ? currentRect.left
          : Number(previousPosition?.left);

      const deltaX = previousLeft - currentRect.left;
      const deltaY = previousTop - currentRect.top;

      if (!Number.isFinite(deltaX) || !Number.isFinite(deltaY)) continue;
      if (Math.abs(deltaX) < 0.5 && Math.abs(deltaY) < 0.5) continue;

      this.#clearFlipForRow(row);

      row.classList.add('eg-cart-row--flip-moving');
      row.style.transition = 'none';
      row.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0)`;
      row.style.willChange = 'transform';

      movedRows.push(row);
    }

    if (!movedRows.length) return;

    movedRows[0].getBoundingClientRect();

    requestAnimationFrame(() => {
      for (const row of movedRows) {
        if (!(row instanceof HTMLElement)) continue;
        if (!row.isConnected) continue;
        if (row.classList.contains('eg-cart-row--pending-remove')) continue;

        row.style.transition = 'transform 180ms ease';
        row.style.transform = 'translate3d(0, 0, 0)';

        const key = row.dataset.key || '';
        if (!key) continue;

        const timer = window.setTimeout(() => {
          this.#flipTimers.delete(key);

          if (!row.isConnected) return;

          row.classList.remove('eg-cart-row--flip-moving');

          if (row.style.transform === 'translate3d(0, 0, 0)') {
            row.style.transition = '';
            row.style.transform = '';
            row.style.willChange = '';
          }
        }, 210);

        this.#flipTimers.set(key, timer);
      }
    });
  }

  #disableRowControls(row) {
    if (!(row instanceof HTMLElement)) return;

    const controls = row.querySelectorAll('button, input, select, textarea');

    controls.forEach((el) => {
      if (
        el instanceof HTMLButtonElement ||
        el instanceof HTMLInputElement ||
        el instanceof HTMLSelectElement ||
        el instanceof HTMLTextAreaElement
      ) {
        if (!el.hasAttribute('data-eg-was-disabled')) {
          el.setAttribute('data-eg-was-disabled', el.disabled ? 'true' : 'false');
        }

        el.disabled = true;
      }
    });

    row.style.pointerEvents = 'none';
  }

  #restoreRowControls(row) {
    if (!(row instanceof HTMLElement)) return;

    const controls = row.querySelectorAll('button, input, select, textarea');

    controls.forEach((el) => {
      if (
        el instanceof HTMLButtonElement ||
        el instanceof HTMLInputElement ||
        el instanceof HTMLSelectElement ||
        el instanceof HTMLTextAreaElement
      ) {
        const prev = el.getAttribute('data-eg-was-disabled');
        el.removeAttribute('data-eg-was-disabled');

        if (prev === 'false') {
          el.disabled = false;
        }
      }
    });

    row.style.pointerEvents = '';
  }

  #setRowPendingRemoval(row, isPending) {
    if (!(row instanceof HTMLElement)) return;

    const isAlreadyPending = row.classList.contains('eg-cart-row--pending-remove');

    if (isPending) {
      if (isAlreadyPending) {
        this.#disableRowControls(row);
        return;
      }

      const previousPositions = this.#captureRowPositions();

      row.setAttribute('aria-busy', 'true');
      row.classList.add('eg-cart-row--pending-remove');
      this.#disableRowControls(row);

      this.#animateRowsFromPreviousPositions(previousPositions);
      egScheduleReflowResize();

      return;
    }

    if (!isAlreadyPending) {
      this.#restoreRowControls(row);
      row.setAttribute('aria-busy', 'false');
      row.classList.remove('eg-cart-row--top-border-while-pending');
      return;
    }

    const previousPositions = this.#captureRowPositions();

    row.classList.remove('eg-cart-row--pending-remove');
    row.classList.remove('eg-cart-row--top-border-while-pending');
    row.setAttribute('aria-busy', 'false');
    this.#restoreRowControls(row);

    row.style.height = '';
    row.style.minHeight = '';
    row.style.maxHeight = '';
    row.style.paddingTop = '';
    row.style.paddingBottom = '';
    row.style.marginTop = '';
    row.style.marginBottom = '';
    row.style.borderTopWidth = '';
    row.style.borderBottomWidth = '';
    row.style.opacity = '';
    row.style.transform = '';
    row.style.pointerEvents = '';
    row.style.overflow = '';
    row.style.transition = '';
    row.style.willChange = '';

    this.#animateRowsFromPreviousPositions(previousPositions);
    egScheduleReflowResize();
  }

  #markTopBorderReplacement(pendingKeys) {
    const rows = this.#getRows();

    rows.forEach((row) => {
      if (row instanceof HTMLElement) {
        row.classList.remove('eg-cart-row--top-border-while-pending');
      }
    });

    if (!this.#isCartDrawerContext()) return;
    if (!pendingKeys.size) return;

    let hasPendingAtTop = false;

    for (const row of rows) {
      if (!(row instanceof HTMLElement)) continue;

      const key = row.dataset.key || '';
      if (!key) continue;

      if (pendingKeys.has(key)) {
        if (!row.classList.contains('eg-cart-row--pending-remove')) continue;

        hasPendingAtTop = true;
        continue;
      }

      if (hasPendingAtTop) {
        row.classList.add('eg-cart-row--top-border-while-pending');
      }

      break;
    }
  }

  #applyPendingStates() {
    const pendingKeys = new Set(this.#getPendingRemovalKeys());
    const rows = this.#getRows();

    rows.forEach((row) => {
      const key = row?.dataset?.key || '';
      this.#setRowPendingRemoval(row, pendingKeys.has(key));
    });

    this.#markTopBorderReplacement(pendingKeys);
    this.#syncCartDrawerLoadingState();
  }

  #clearPendingStateForKey(key) {
    if (!key) return;

    const row = this.#findRowByKey(key);

    if (row) {
      this.#setRowPendingRemoval(row, false);
    }

    this.#applyPendingStates();
  }

  #clearPendingStateForMutations(mutations) {
    for (const mutation of mutations || []) {
      this.#clearPendingStateForKey(mutation?.key || '');
    }
  }

  #isBatchableRemovalMutation(mutation) {
    if (mutation?.quantity !== 0) return false;

    const key = String(mutation?.key || '');

    return Boolean(key && !key.startsWith('line:'));
  }

  #scheduleQueuedMutationProcessing(mutation) {
    if (this.#isCartMutationInFlight) return;

    this.#processNextQueuedMutation();
  }

  #enqueueMutation(mutation) {
    const stableKey =
      mutation.key ||
      this.#getRowKeyByLine(mutation.line) ||
      `line:${mutation.line}`;

    this.#queuedMutations.set(stableKey, {
      ...mutation,
      key: stableKey,
    });

    this.#applyPendingStates();
    this.#scheduleQueuedMutationProcessing(this.#queuedMutations.get(stableKey));
  }

  #processNextQueuedMutation() {
    if (this.#isCartMutationInFlight) return;

    const iterator = this.#queuedMutations.entries().next();
    if (iterator.done) return;

    const [mapKey, mutation] = iterator.value;

    this.#queuedMutations.delete(mapKey);

    if (this.#isBatchableRemovalMutation(mutation)) {
      const removalBatch = [mutation];

      for (const [queuedKey, queuedMutation] of Array.from(this.#queuedMutations.entries())) {
        if (!this.#isBatchableRemovalMutation(queuedMutation)) continue;

        removalBatch.push(queuedMutation);
        this.#queuedMutations.delete(queuedKey);
      }

      if (removalBatch.length > 1) {
        this.#sendCartRemovalBatch(removalBatch);
        return;
      }
    }

    this.#activeMutation = mutation;
    this.#sendCartMutation(mutation);
  }

  #getCartSectionsToUpdate() {
    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionsToUpdate = new Set([this.sectionId]);

    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToUpdate.add(item.dataset.sectionId);
      }
    });

    return sectionsToUpdate;
  }

  #scheduleDeferredCartMutationResponseFlush(delay = 260) {
    if (this.#deferredCartMutationTimer) {
      window.clearTimeout(this.#deferredCartMutationTimer);
    }

    this.#deferredCartMutationTimer = window.setTimeout(() => {
      this.#deferredCartMutationTimer = null;
      this.#flushDeferredCartMutationResponse();
    }, Math.max(0, Number(delay || 0)));
  }

  #flushDeferredCartMutationResponse() {
    const response = this.#deferredCartMutationResponse;

    if (!response) {
      return;
    }

    if (this.#isAnyCartDrawerClosing()) {
      this.#scheduleDeferredCartMutationResponseFlush(140);
      return;
    }

    this.#deferredCartMutationResponse = null;

    if (this.#deferredCartMutationTimer) {
      window.clearTimeout(this.#deferredCartMutationTimer);
      this.#deferredCartMutationTimer = null;
    }

    this.#applyCartMutationResponse(response, { force: true });
  }

  #deferCartMutationResponse(parsedResponseText) {
    this.#deferredCartMutationResponse = parsedResponseText;
    this.#scheduleDeferredCartMutationResponseFlush(260);
  }

  #applyCartMutationResponse(parsedResponseText, options = {}) {
    if (!options.force && this.#isAnyCartDrawerClosing()) {
      this.#deferCartMutationResponse(parsedResponseText);
      return;
    }

    const rawSectionHtml = parsedResponseText.sections?.[this.sectionId];
    const realCartCount =
      this.#readCountFromSectionHtml(rawSectionHtml) ??
      this.#normalizeCount(parsedResponseText.item_count);

    if (realCartCount !== null) {
      this.#lastConfirmedCartCount = realCartCount;
    }

    if (!rawSectionHtml) {
      this.#updateQuantitySelectors(parsedResponseText);
      return;
    }

    const preparedSectionHtml = this.#prepareSectionHtmlWithPendingStates(rawSectionHtml);

    parsedResponseText.sections[this.sectionId] = preparedSectionHtml;

    this.#updateQuantitySelectors(parsedResponseText);

    this.dispatchEvent(
      new CartUpdateEvent(parsedResponseText, this.sectionId, {
        itemCount: realCartCount ?? undefined,
        source: 'cart-items-component',
        sections: parsedResponseText.sections,
      })
    );

    if (this._isEgHeaderContext()) {
      this._morphSelfFromSectionHtml(preparedSectionHtml);
      return;
    }

    morphSection(this.sectionId, preparedSectionHtml);

    queueMicrotask(() => {
      this.#updateCartQuantitySelectorButtonStates();
      this.#applyPendingStates();

      if (this.#cartMetaLoading) {
        this.#setCartMetaLoadingState();
      } else {
        this.#syncCartDrawerLoadingState();
      }

      egScheduleReflowResize();
    });
  }

  #sendCartMutation(mutation) {
    const resolvedLine = this.#resolveLineFromMutation(mutation);

    if (!resolvedLine) {
      this.#clearPendingStateForKey(mutation?.key || '');
      this.#activeMutation = null;
      this.#processNextQueuedMutation();
      return;
    }

    const requestId = ++this.#requestSequence;
    this.#isCartMutationInFlight = true;
    this.#startCartMetaLoading();

    const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${mutation.action}:user-action`);
    const { cartTotal } = this.refs;
    const sectionsToUpdate = this.#getCartSectionsToUpdate();

    const body = JSON.stringify({
      line: resolvedLine,
      quantity: mutation.quantity,
      sections: Array.from(sectionsToUpdate).join(','),
      sections_url: window.location.pathname,
    });

    cartTotal?.shimmer();

    fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
      .then((response) => response.text())
      .then((responseText) => {
        if (requestId !== this.#requestSequence) return;

        const parsedResponseText = JSON.parse(responseText);
        resetShimmer(this);

        if (parsedResponseText.errors) {
          this.#activeMutation = null;
          this.#handleCartError(resolvedLine, parsedResponseText);
          this.#clearPendingStateForKey(mutation?.key || '');
          return;
        }

        this.#activeMutation = null;
        this.#applyCartMutationResponse(parsedResponseText);
      })
      .catch((error) => {
        if (requestId !== this.#requestSequence) return;

        console.error(error);

        this.#activeMutation = null;
        this.#clearPendingStateForKey(mutation?.key || '');

        if (this._isEgHeaderContext()) {
          void this._renderSelfFromSectionApi();
        } else {
          sectionRenderer.renderSection(this.sectionId, { cache: false });
        }
      })
      .finally(() => {
        if (requestId !== this.#requestSequence) return;

        this.#isCartMutationInFlight = false;
        this.#activeMutation = null;

        cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);

        if (this.#queuedMutations.size > 0) {
          this.#processNextQueuedMutation();
          return;
        }

        this.#finishCartMetaLoading(this.#lastConfirmedCartCount);
      });
  }

  #sendCartRemovalBatch(mutations) {
    return this.#sendCartRemovalBatchWithOptions(mutations);
  }

  #sendCartRemovalBatchWithOptions(mutations, options = {}) {
    const batch = (mutations || []).filter((mutation) => this.#isBatchableRemovalMutation(mutation));

    if (!batch.length) {
      this.#processNextQueuedMutation();
      return;
    }

    const requestId = ++this.#requestSequence;
    this.#isCartMutationInFlight = true;
    this.#activeMutation = null;
    this.#activeBatchMutations = batch;
    this.#startCartMetaLoading();

    const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker('clear-batch:user-action');
    const { cartTotal } = this.refs;
    const sectionsToUpdate = this.#getCartSectionsToUpdate();
    const updates = {};

    for (const mutation of batch) {
      updates[mutation.key] = 0;
    }

    const body = JSON.stringify({
      updates,
      sections: Array.from(sectionsToUpdate).join(','),
      sections_url: window.location.pathname,
    });

    cartTotal?.shimmer();

    fetch(`${Theme.routes.cart_update_url}`, fetchConfig('json', { body }))
      .then((response) => response.text())
      .then((responseText) => {
        if (requestId !== this.#requestSequence) return;

        const parsedResponseText = JSON.parse(responseText);
        resetShimmer(this);

        if (parsedResponseText.errors) {
          this.#activeBatchMutations = [];
          this.#clearPendingStateForMutations(batch);
          return;
        }

        this.#activeBatchMutations = [];
        this.#applyCartMutationResponse(parsedResponseText);

        if (options.showUndo) {
          Promise.resolve(options.snapshotPromise)
            .then((snapshot) => {
              const undoItems = this.#buildUndoItemsFromCartSnapshot(snapshot);

              if (!undoItems.length) return;

              this.#clearCartUndoItems = undoItems;
              this.#showClearCartUndoToast();
            })
            .catch(() => {});
        }

        if (options.closeDrawerAfterSuccess) {
          this.#closeOpenCartDrawers();
        }
      })
      .catch((error) => {
        if (requestId !== this.#requestSequence) return;

        console.error(error);

        this.#activeBatchMutations = [];
        this.#clearPendingStateForMutations(batch);

        if (this._isEgHeaderContext()) {
          void this._renderSelfFromSectionApi();
        } else {
          sectionRenderer.renderSection(this.sectionId, { cache: false });
        }
      })
      .finally(() => {
        if (requestId !== this.#requestSequence) return;

        this.#isCartMutationInFlight = false;
        this.#activeBatchMutations = [];

        cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);

        if (this.#queuedMutations.size > 0) {
          this.#processNextQueuedMutation();
          return;
        }

        this.#finishCartMetaLoading(this.#lastConfirmedCartCount);
      });
  }

  #onQuantityChange(event) {
    if (!(event.target instanceof Node) || !this.contains(event.target)) return;

    const { quantity, cartLine: line } = event.detail;
    const normalizedLine = this.#normalizeLine(line);

    if (!normalizedLine) return;

    const row =
      this.#resolveRowFromEvent(event) ||
      this.#getRowByLine(normalizedLine);

    const itemKey = row?.dataset?.key || this.#getRowKeyByLine(normalizedLine) || '';

    if (quantity === 0) {
      this.onLineItemRemove(normalizedLine, event);
      return;
    }

    this.#resetManualRemovalStreak();
    this.#hideClearCartUndoToast();
    this.#startCartMetaLoading();

    this.updateQuantity({
      line: normalizedLine,
      key: itemKey,
      quantity,
      action: 'change',
    });

    const lineItemRow = this.#getRowByLine(normalizedLine);
    if (!lineItemRow) return;

    const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
    textComponent?.shimmer();
  }

  onLineItemRemove(line, eventOrKey = '') {
    const normalizedLine = this.#normalizeLine(line);

    if (!normalizedLine) return;

    const rowFromEvent =
      eventOrKey instanceof Event
        ? this.#resolveRowFromEvent(eventOrKey)
        : null;

    const keyFromEvent =
      rowFromEvent?.dataset?.key ||
      (typeof eventOrKey === 'string' ? eventOrKey : '') ||
      this.#getRowKeyByLine(normalizedLine) ||
      '';

    const row =
      rowFromEvent ||
      (keyFromEvent ? this.#findRowByKey(keyFromEvent) : null) ||
      this.#getRowByLine(normalizedLine);

    if (row) {
      this.#setRowPendingRemoval(row, true);

      const childRows = this.#getRows().filter(
        (candidate) => candidate.dataset.parentKey === row.dataset.key
      );

      childRows.forEach((childRow) => this.#setRowPendingRemoval(childRow, true));
    }

    this.#recordManualRemoval();
    this.#hideClearCartUndoToast();
    this.#startCartMetaLoading();

    this.updateQuantity({
      line: normalizedLine,
      key: keyFromEvent,
      quantity: 0,
      action: 'clear',
      removedQuantity: row ? this.#getRowQuantity(row) : 1,
    });
  }

  async onClearCart(event) {
    event?.preventDefault?.();

    if (this.#hasPendingCartMutation()) return;

    const rows = this.#getRows().filter((row) => {
      return row instanceof HTMLElement &&
        row.isConnected &&
        !row.classList.contains('eg-cart-row--pending-remove');
    });

    if (!rows.length) return;

    const mutations = [];

    rows.forEach((row, index) => {
      const key = row.dataset.key || '';
      if (!key) return;

      const lineFromInput = Number(row.querySelector('input[data-cart-line]')?.dataset?.cartLine || 0);
      const line = lineFromInput > 0 ? lineFromInput : index + 1;

      this.#setRowPendingRemoval(row, true);

      mutations.push({
        line,
        key,
        quantity: 0,
        action: 'clear',
        removedQuantity: this.#getRowQuantity(row),
      });
    });

    if (!mutations.length) return;

    const snapshotPromise = this.#fetchCartSnapshotForUndo().catch(() => null);

    this.#resetManualRemovalStreak();
    this.#startCartMetaLoading();
    this.#sendCartRemovalBatchWithOptions(mutations, {
      showUndo: true,
      snapshotPromise,
      closeDrawerAfterSuccess: true,
    });
  }

  #closeOpenCartDrawers() {
    for (const root of this.#getCartDrawerRoots()) {
      if (!this.#isCartDrawerRootOpen(root)) continue;

      try {
        if (typeof root.close === 'function') {
          root.close();
          continue;
        }
      } catch (_) {}

      const dialog = root.querySelector?.('dialog[open]');

      try {
        dialog?.close?.();
      } catch (_) {}
    }
  }

  async #fetchCartSnapshotForUndo() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error(`Cart snapshot failed: ${response.status}`);
    }

    return response.json();
  }

  #buildUndoItemsFromCartSnapshot(cart) {
    if (!Array.isArray(cart?.items)) return [];

    return cart.items
      .map((item) => {
        const id = Number(item?.variant_id || item?.id || 0);
        const quantity = Number(item?.quantity || 0);

        if (!id || !quantity) return null;

        const properties =
          item?.properties && Object.keys(item.properties).length > 0
            ? item.properties
            : undefined;

        const sellingPlan =
          item?.selling_plan_allocation?.selling_plan?.id ||
          item?.selling_plan_allocation?.selling_plan_id ||
          item?.selling_plan_id ||
          undefined;

        return {
          id,
          quantity,
          ...(properties ? { properties } : {}),
          ...(sellingPlan ? { selling_plan: sellingPlan } : {}),
        };
      })
      .filter(Boolean);
  }

  #showClearCartUndoToast() {
    this.#hideClearCartUndoToast();

    const toast = document.createElement('div');
    toast.className = 'eg-cart-undo-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = `
      <span>Cart cleared</span>
      <button type="button" class="eg-cart-undo-toast__button">Undo</button>
    `;

    const button = toast.querySelector('button');
    button?.addEventListener('click', this.#handleUndoClearCartClick);

    document.body.appendChild(toast);
    this.#clearCartUndoToast = toast;

    requestAnimationFrame(() => {
      toast.setAttribute('data-visible', 'true');
    });

    this.#clearCartUndoTimer = window.setTimeout(() => {
      this.#hideClearCartUndoToast();
    }, 6500);
  }

  #hideClearCartUndoToast() {
    if (this.#clearCartUndoTimer) {
      window.clearTimeout(this.#clearCartUndoTimer);
      this.#clearCartUndoTimer = null;
    }

    const toast = this.#clearCartUndoToast;
    if (!toast) return;

    toast.removeAttribute('data-visible');

    window.setTimeout(() => {
      toast.remove();

      if (this.#clearCartUndoToast === toast) {
        this.#clearCartUndoToast = null;
      }
    }, 190);
  }

  #handleUndoClearCartClick = async (event) => {
    event?.preventDefault?.();

    const items = this.#clearCartUndoItems;
    if (!items.length) return;

    const button = event?.currentTarget;
    if (button instanceof HTMLButtonElement) {
      button.disabled = true;
    }

    try {
      const body = JSON.stringify({ items });
      const response = await fetch(Theme.routes.cart_add_url, fetchConfig('json', { body }));
      const parsedResponse = await response.json();

      if (!response.ok || parsedResponse?.status) {
        throw new Error(parsedResponse?.description || `Undo add failed: ${response.status}`);
      }

      this.#clearCartUndoItems = [];
      this.#hideClearCartUndoToast();

      let latestCart = null;

      try {
        latestCart = await this.#fetchCartSnapshotForUndo();
      } catch (_) {}

      this.dispatchEvent(
        new CartUpdateEvent(latestCart || {}, this.sectionId, {
          itemCount: latestCart ? Number(latestCart.item_count || 0) : undefined,
          source: 'cart-clear-undo',
        })
      );

      if (this._isEgHeaderContext()) {
        void this._renderSelfFromSectionApi();
      } else {
        sectionRenderer.renderSection(this.sectionId, { cache: false });
      }
    } catch (error) {
      console.error(error);

      if (button instanceof HTMLButtonElement) {
        button.disabled = false;
      }
    }
  };

  updateQuantity(config) {
    this.#enqueueMutation(config);
  }

  handleDiscountUpdate = (event) => {
    this.#handleCartUpdate(event);
  };

  #handleCartError = (line, parsedResponseText) => {
    const quantitySelector = this.refs.quantitySelectors?.[line - 1];
    const quantityInput = quantitySelector?.querySelector('input');

    if (!quantityInput) return;

    quantityInput.value = quantityInput.defaultValue;

    const cartItemError = this.refs[`cartItemError-${line}`];
    const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

    if (!(cartItemError instanceof HTMLElement)) return;
    if (!(cartItemErrorContainer instanceof HTMLElement)) return;

    cartItemError.textContent = parsedResponseText.errors;
    cartItemErrorContainer.classList.remove('hidden');
  };

  #handleCartUpdate = (event) => {
    if (event instanceof DiscountUpdateEvent) {
      if (this._isEgHeaderContext()) {
        void this._renderSelfFromSectionApi();
      } else {
        sectionRenderer.renderSection(this.sectionId, { cache: false });
      }

      return;
    }

    if (event?.target === this) return;

    const cartItemsHtml = event.detail?.data?.sections?.[this.sectionId];
    const incomingCount =
      this.#readAbsoluteCountFromCartUpdateEvent(event) ??
      this.#readCountFromSectionHtml(cartItemsHtml);

    if (incomingCount !== null) {
      this.#lastConfirmedCartCount = incomingCount;
    }

    if (cartItemsHtml) {
      const preparedCartItemsHtml = this.#prepareSectionHtmlWithPendingStates(cartItemsHtml);

      if (this._isEgHeaderContext()) {
        this._morphSelfFromSectionHtml(preparedCartItemsHtml);

        if (!this.#hasPendingCartMutation() && incomingCount !== null) {
          this.#finishCartMetaLoading(incomingCount);
        }

        return;
      }

      morphSection(this.sectionId, preparedCartItemsHtml);

      queueMicrotask(() => {
        this.#updateCartQuantitySelectorButtonStates();
        this.#applyPendingStates();

        if (this.#cartMetaLoading) {
          this.#setCartMetaLoadingState();
        }

        if (!this.#hasPendingCartMutation() && incomingCount !== null) {
          this.#finishCartMetaLoading(incomingCount);
        }

        egScheduleReflowResize();
      });

      return;
    }

    if (incomingCount !== null && !this.#hasPendingCartMutation()) {
      this.#finishCartMetaLoading(incomingCount);
      return;
    }

    if (this._isEgHeaderContext()) {
      void this._renderSelfFromSectionApi();
    } else {
      sectionRenderer.renderSection(this.sectionId, { cache: false });
    }
  };

  #updateQuantitySelectors(updatedCart) {
    if (!updatedCart.items) return;

    for (const item of updatedCart.items) {
      const variantId = item.variant_id.toString();
      const selectors = document.querySelectorAll(`quantity-selector-component[data-variant-id="${variantId}"]`);

      for (const selector of selectors) {
        const input = selector.querySelector('input[data-cart-quantity]');
        if (!input) continue;

        input.setAttribute('data-cart-quantity', item.quantity.toString());

        if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
          selector.updateCartQuantity();
        }
      }
    }
  }

  #updateCartQuantitySelectorButtonStates() {
    for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
      /** @type {any} */ (selector).updateButtonStates?.();
    }
  }

  get sectionId() {
    const { sectionId } = this.dataset;

    if (!sectionId) throw new Error('Section id missing');

    return sectionId;
  }
}

if (!customElements.get('cart-items-component')) {
  customElements.define('cart-items-component', CartItemsComponent);
}
